export type ApiEnvironment = 'development' | 'shared' | 'stage' | 'production'

function getFinanzcheckBasePath(environment: ApiEnvironment): string {
  switch (environment) {
    case 'development':
      return process.env.DEVELOPMENT_BASE_PATH ?? ''
    case 'shared':
      return 'https://ti-fintec.finanzcheck-shared.de'
    case 'stage':
      return 'https://ti-fintec.finanzcheck-stage.de'
    default:
      return 'https://ti-fintec.finanzcheck.de'
  }
}

function getSmavaBasePath(environment: ApiEnvironment): string {
  switch (environment) {
    case 'development':
      return process.env.DEVELOPMENT_BASE_PATH ?? ''
    case 'shared':
      return 'https://ti-fintec.smava-shared.de'
    case 'stage':
      return 'https://ti-fintec.smava-stage.de'
    default:
      return 'https://ti-fintec.smava.de'
  }
}

const clientConfig = {
  smava: {
    getBasePath: getSmavaBasePath,
  },
  finanzcheck: {
    getBasePath: getFinanzcheckBasePath,
  },
}

export function getCorsConfiguration(
  environment: ApiEnvironment,
): object | undefined {
  if (environment !== 'development') {
    return {
      mode: 'cors',
      credentials: 'include',
    }
  }
  return undefined
}

export function getBasePath(environment: ApiEnvironment): string {
  const { origin, hostname } = window.location
  const matchedDomain = Object.keys(clientConfig).find((domain) =>
    origin.includes(domain),
  )

  if (!matchedDomain) {
    if (hostname === 'localhost') {
      return clientConfig.finanzcheck.getBasePath(environment)
    }
    throw new Error(`ti-fts-widget could not find api config for ${origin}`)
  }
  return clientConfig[matchedDomain].getBasePath(environment)
}
